export interface IResponse<T> {
  data: T;
}

export interface IResponsePagination {
  limit: number;
  offset: number;
  total: number;
}

interface IPayloadError {
  message: string;
  locations: { line: number; column: number }[];
  extensions: any;
}

interface IErrorPayload {
  errors?: IPayloadError[];
}

type GraphQLPayload<T = Record<string, unknown>> = {
  data: T;
  pagination: IResponsePagination;
};

export type GraphQLResponse<K extends string, T> = Record<K, GraphQLPayload<T>> & IErrorPayload;
export type GraphQLResponseTitan<K extends string, T> = Record<K, T> & IErrorPayload;
